import { InjectionToken } from '@angular/core';

export const ENV_RELEASE_VERSION = new InjectionToken<string>('Environment Release Version', {
  factory: () => '0.0.0',
});
